import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import styled from "styled-components";
import { Button } from "../../ui";
import { GET_CONTRACT } from "../../../services/contract/contracts";
import { ModalForm } from "../../../components/form";
import ModalContainer from "../../ModalContainer";
import { useContract } from "../../../redux/contractReducer";
const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  margin-bottom: 30px;
  @media only screen and (max-width: 1280px) {
    width: 100vw;
    padding: 40px 20px;
  }
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--primary-pistachio);
`;

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 300px);
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 18px;
  justify-content: space-between;
  margin-top: 14px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  } ;
`;

const StyledTextWrapper = styled.div`
  display: flex;
`;

const StyledText = styled.p`
  font-weight: 400;
  color: var(--neutrals-charcoal);
  font-size: 16px;
`;

const StyledTextBold = styled.p`
  font-weight: 800;
  color: var(--neutrals-charcoal);
  font-size: 16px;
`;

const Description = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--neutrals-light-gray);
  margin-bottom: 10px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
`;

export const DatosContacto = ({
  dataContact = null,
  setContractSelected = () => {},
}) => {
  const [contact, setContact] = useState([]);
  const { setContract, contractState } = useContract();
  const [showModal, setShowModal] = useState(false);

  const [getAllContractById] = useLazyQuery(GET_CONTRACT, {
    fetchPolicy: "network-only",
    onCompleted({ getAllContractById }) {
      if (getAllContractById.statusCode === 200) {
        const resultFormatJson = JSON.parse(getAllContractById.response);
        setContact(resultFormatJson);
        setContract({
          ...contractState,
          ...resultFormatJson[0],
          valor_est_cont: resultFormatJson[0].valor_est_cont,
        });
      }
    },
  });

  const transformDate = (data) => {
    const formatDate = new Date(data);
    const result = formatDate.toLocaleDateString("es-MX", data);
    return result;
  };

  useEffect(() => {
    if (dataContact) {
      getAllContractById({
        variables: {
          idContract: dataContact.contrato_id,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContact]);

  return (
    <>
      <ModalContainer
        showModal={showModal}
        closeModal={() => setShowModal(false)}
      >
        <ModalForm>
          <ModalContent>
            <ModuleTitle>Capturar Siniestro</ModuleTitle>
            <Description>
              ¿Estas seguro que quieres capturar un siniestro para este
              contrato?{" "}
            </Description>

            <div
              style={{ width: "100%", display: "grid", placeContent: "center" }}
            >
              <Button
                text={"Si, quiero capturar un siniestro"}
                style={{ borderRadius: "20px" }}
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  setContractSelected(dataContact);
                  setShowModal(false);
                }}
              />
            </div>
          </ModalContent>
        </ModalForm>{" "}
      </ModalContainer>
      {contact.length > 0 ? (
        <>
          {contact.map((contract, index) => (
            <div key={index}>
              <ModuleContainer>
                <ModuleTitle>Datos del contrato</ModuleTitle>
                <Divider />
                <DataContainer>
                  <StyledTextWrapper>
                    <StyledTextBold>Nombre del cliente:</StyledTextBold>
                    <StyledText>{contract.nombre}</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold> Estatus de la póliza :</StyledTextBold>
                    <StyledText>{contract.valor_est_cont}</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold>Suma asegurada: </StyledTextBold>
                    <StyledText>{contract.sum}</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold>Número del contrato: #</StyledTextBold>
                    <StyledText>
                      {String(contract.contrato_id).padStart(4, "0")}
                    </StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold> Fecha de emisión: </StyledTextBold>
                    <StyledText>{transformDate(contract.fecha_emi)}</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold> % de participación:</StyledTextBold>
                    <StyledText>{contract.porcentaje} %</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold>Vigencia del contrato: </StyledTextBold>
                    <StyledText>
                      {transformDate(contract.fecha_ini)} -{" "}
                      {transformDate(contract.fecha_fin)}{" "}
                    </StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold>Ramo: </StyledTextBold>
                    <StyledText>{contract.valor_ramo}</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper>
                    <StyledTextBold>Moneda:</StyledTextBold>
                    <StyledText> {contract.valor_moneda}</StyledText>
                  </StyledTextWrapper>
                </DataContainer>
                <Button
                  text={"Comenzar captura de siniestro"}
                  color="var(--primary-pistachio)"
                  style={{ borderRadius: "20px", alignSelf: "flex-end" }}
                  outlined
                  onClick={() =>
                    //setContractSelected(dataContact)
                    setShowModal(true)
                  }
                />
              </ModuleContainer>
            </div>
          ))}
        </>
      ) : (
        <div>
          <ModuleContainer>
            <ModuleTitle>Datos del contrato</ModuleTitle>
            <Divider />
            <DataContainer>
              <StyledTextWrapper>
                <StyledTextBold>Nombre del cliente: </StyledTextBold>
                <StyledText> Nombre</StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Estatus de la póliza: </StyledTextBold>
                <StyledText> Estatus</StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Suma asegurada:</StyledTextBold>
                <StyledText> $0</StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Número del contrato:</StyledTextBold>
                <StyledText> #00000</StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Fecha de emisión:</StyledTextBold>
                <StyledText>00/00/0000</StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>% de participación:</StyledTextBold>
                <StyledText> %0 </StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Vigencia del contrato:</StyledTextBold>
                <StyledText>00/00/0000 - 00/00/0000 </StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Ramo:</StyledTextBold>
                <StyledText> Ramo </StyledText>
              </StyledTextWrapper>
              <StyledTextWrapper>
                <StyledTextBold>Moneda:</StyledTextBold>
                <StyledText> USD/MXP</StyledText>
              </StyledTextWrapper>
            </DataContainer>
            <ButtonWrapper>
              <Button
                text={"Comenzar captura de siniestro"}
                color="var(--primary-pistachio)"
                style={{ borderRadius: "20px", alignSelf: "flex-end" }}
                outlined
                onClick={() =>
                  //setContractSelected(dataContact)
                  setShowModal(true)
                }
              />
            </ButtonWrapper>
          </ModuleContainer>
        </div>
      )}
    </>
  );
};
